import { render, staticRenderFns } from "./CampaignParams.vue?vue&type=template&id=390c0653&scoped=true&"
import script from "./CampaignParams.vue?vue&type=script&lang=js&"
export * from "./CampaignParams.vue?vue&type=script&lang=js&"
import style0 from "./CampaignParams.vue?vue&type=style&index=0&id=390c0653&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390c0653",
  null
  
)

export default component.exports